import type { RefObject } from 'react';
import { findTransitionController } from '../../../../util/core-transition-component';
import type { HeadingRef } from '../../../atoms/heading/Heading.data';

interface ServicesCtaItemRefs {
  elementRef?: RefObject<HTMLElement | null>;
  hoverTextRef?: RefObject<HTMLSpanElement | null>;
  backgroundRef?: RefObject<HTMLDivElement | null>;
  lineRef?: RefObject<HTMLSpanElement | null>;
  titleRef?: RefObject<HeadingRef | null>;
  numberRef?: RefObject<HeadingRef | null>;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { lineRef, numberRef, titleRef }: ServicesCtaItemRefs,
): void {
  const numberController = findTransitionController(numberRef);
  const titleController = findTransitionController(titleRef);

  if (lineRef?.current) {
    timeline.fromTo(
      lineRef.current,
      { scaleX: 0, transformOrigin: 'left center' },
      { duration: 0.5, ease: 'Quad.easeInOut', scaleX: 1 },
    );
  }

  if (numberController) {
    timeline.add(numberController.getTimeline('in') as gsap.core.Timeline, 0);
  }
  if (titleController) {
    timeline.add(titleController.getTimeline('in') as gsap.core.Timeline, 0.05);
  }
}

export function setupMouseEnterTimeline(
  timeline: gsap.core.Timeline,
  { hoverTextRef, backgroundRef }: ServicesCtaItemRefs,
): void {
  const hoverTextController = findTransitionController(hoverTextRef);

  if (backgroundRef?.current) {
    timeline.fromTo(
      backgroundRef.current,
      { scaleY: 0 },
      { duration: 0.4, ease: 'Expo.easeOut', scaleY: 1 },
    );
  }

  if (hoverTextController) {
    timeline.add(hoverTextController.getTimeline('in') as gsap.core.Timeline, 0);
  }
}

export function setupMouseLeaveTimeline(
  timeline: gsap.core.Timeline,
  { hoverTextRef, backgroundRef }: ServicesCtaItemRefs,
): void {
  const hoverTextController = findTransitionController(hoverTextRef);

  if (backgroundRef?.current) {
    timeline.to(backgroundRef.current, { duration: 0.4, ease: 'Expo.easeOut', scaleY: 0 });
  }

  if (hoverTextController) {
    timeline.add(hoverTextController.getTimeline('out') as gsap.core.Timeline, 0);
  }
}
